





















import { Component, Vue } from "vue-property-decorator";
import Head from "./components/haed.vue";
import Modules from "./components/modules.vue";

@Component({
  components: {
    Head,
    Modules,
  },
})
export default class Logout extends Vue {
  public ruleOverview = "";

  public async getText(e) {
    this.ruleOverview = e;
  }

  public onNavClick() {
    (window as any).sendCallNativeBack();
  }
}
